import { useCallback, useMemo } from "react";

import { useFormikContext } from "formik";

import FormikEditor from "@sso/components/Formik/FormikEditor";
import { PaymentType, SoftwareLicenceFormValues } from "@sso/types";
import { CustomForm } from "@sso/ui/CustomForm";

import DialogStepper, { FormSections } from "../../DialogStepper/DialogStepper";
import PricingForm from "../../Pricing/pricingForm";
import LicenceTypeGeneralFields from "./general";
import { featureStepSchema, generalStepSchema, pricingStepSchema, specificStepSchema } from "./schema";
import LicenceTypeSpecificFields from "./specific";

enum FormKeys {
  GENERAL = "general",
  SPECIFIC = "specific",
  PRICING = "pricing",
  FEATURES = "features",
}

const LicenceTypeAddForm = () => {
  const { values } = useFormikContext<SoftwareLicenceFormValues>();

  const formSections = useMemo<FormSections[]>(() => {
    return [
      {
        formKey: FormKeys.GENERAL,
        include: true,
        schema: generalStepSchema,
      },
      {
        formKey: FormKeys.SPECIFIC,
        include: values.paymentType !== PaymentType.PaymentOnAccount,
        schema: specificStepSchema,
      },
      {
        formKey: FormKeys.PRICING,
        include: values.paymentType !== PaymentType.Free,
        schema: pricingStepSchema,
      },
      {
        formKey: FormKeys.FEATURES,
        include: true,
        schema: featureStepSchema,
      },
    ];
  }, [values]);

  const renderSectionComponent = useCallback(
    (formKey: string) => {
      switch (formKey) {
        case FormKeys.GENERAL:
          return <LicenceTypeGeneralFields />;
        case FormKeys.SPECIFIC:
          return <LicenceTypeSpecificFields />;
        case FormKeys.PRICING:
          return values.licenceType ? <PricingForm licenceType={values.licenceType} /> : null;
        case FormKeys.FEATURES:
          return <FormikEditor label="Feature Text" name="featureHtml" />;
        default:
          return null;
      }
    },
    [values],
  );

  return (
    <>
      <CustomForm padding="1rem 0" width="100%" overflow="hidden">
        <DialogStepper renderSectionComponent={renderSectionComponent} formSections={formSections} />
      </CustomForm>
    </>
  );
};

export default LicenceTypeAddForm;
